"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDOBByAge = exports.transformCaseInsensitive = exports.paymentNameFormatter = exports.capitalize = exports.parseCloudinaryQuality = void 0;
const homi_shared_1 = require("@getgreenline/homi-shared");
const dayjs_1 = require("./dayjs");
const parseCloudinaryQuality = (imageSrc, termToAdd) => {
    if (!imageSrc) {
        return null;
    }
    if (imageSrc.includes('cloudinary.com')) {
        let terms = [];
        if (!imageSrc.includes('q_auto,f_auto')) {
            terms = ['q_auto,f_auto'];
            if (termToAdd) {
                terms = [...terms, ...termToAdd];
            }
        }
        else {
            if (termToAdd) {
                terms = [...termToAdd];
            }
        }
        const termsQuery = terms.join('/');
        const searchTermUpload = 'upload/';
        const searchTermUploadIndex = imageSrc.indexOf(searchTermUpload);
        if (searchTermUploadIndex >= 0) {
            return `${imageSrc.slice(0, searchTermUploadIndex + searchTermUpload.length)}${termsQuery}/${imageSrc.slice(searchTermUploadIndex + searchTermUpload.length)}`;
        }
        const searchTermFetch = 'fetch/';
        const searchTermFetchIndex = imageSrc.indexOf(searchTermFetch);
        if (searchTermFetchIndex >= 0) {
            return `${imageSrc.slice(0, searchTermFetchIndex + searchTermFetch.length)}${termsQuery}/${imageSrc.slice(searchTermFetchIndex + searchTermFetch.length)}`;
        }
    }
    return imageSrc;
};
exports.parseCloudinaryQuality = parseCloudinaryQuality;
const capitalize = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1);
};
exports.capitalize = capitalize;
const paymentNameFormatter = (paymentTypeId) => {
    switch (paymentTypeId) {
        case homi_shared_1.PaymentTypeIds.etransfer:
            return 'E-Transfer';
        case homi_shared_1.PaymentTypeIds.merrcoDataCandy:
            return 'Merrco gift card';
        case homi_shared_1.PaymentTypeIds.birchmount:
            return 'Birchmount gift card';
        default:
            return (0, exports.capitalize)(homi_shared_1.PaymentTypeIds[paymentTypeId]);
    }
};
exports.paymentNameFormatter = paymentNameFormatter;
const transformCaseInsensitive = (params) => {
    const value = params.obj[params.key];
    if (value !== undefined) {
        return value;
    }
    const lowerCasedKeyValue = params.obj[params.key.toLowerCase()];
    if (lowerCasedKeyValue !== undefined) {
        return lowerCasedKeyValue;
    }
    const upperCasedKeyValue = params.obj[params.key.toUpperCase()];
    return upperCasedKeyValue;
};
exports.transformCaseInsensitive = transformCaseInsensitive;
const getDOBByAge = (age) => {
    return (0, dayjs_1.dayjs)().subtract(age, 'years').format('YYYY-MM-DD');
};
exports.getDOBByAge = getDOBByAge;
//# sourceMappingURL=StringHelper.js.map